import { reactive } from 'vue';
import { TAnimationFlows } from '@/common/types/animation-types/TAnimationFlows';

export const animationState = reactive({
    flow: 'left-to-right' as TAnimationFlows
});